<script setup lang="ts">

useHead({
  title: 'AugmentBLU | Laravel Development & CMS Migration, Edinburgh',
  titleTemplate: '',
  meta: [
    { name: 'description', content: 'Edinburgh-based Laravel development studio with 24+ years experience. Enterprise web applications, CMS migrations, Vue.js & Nuxt frontends. 150+ projects delivered.' },
    { property: 'og:title', content: 'AugmentBLU | Laravel Development & CMS Migration Specialists' },
    { property: 'og:description', content: 'Edinburgh-based Laravel specialists. Enterprise web apps, CMS migrations, Vue.js & Nuxt frontends. 24+ years experience.' },
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: 'https://augmentblu.co.uk/' },
  ],
  link: [{ rel: 'canonical', href: 'https://augmentblu.co.uk/' }],
})
</script>

<template>
  <main>
    <HomeHero />
    <ServicesSection />
    <WorkTeaser />
    <AboutSection />
    <MigrationTeaser />
    <SupportSection />
    <ProcessSection />
    <PartnershipsSection />

    <section class="py-20 md:py-20 relative">
      <div class="pt-16 overflow-hidden">
        <p data-aos="fade" class="text-xs text-slate-700/75 dark:text-white/50 uppercase tracking-wider mb-4 max-w-7xl mx-auto px-6 md:px-12">Trusted by</p>
        <div data-aos="fade" data-aos-delay="100">
          <ClientMarquee />
        </div>
      </div>
    </section>

    <LatestPosts />

    <section class="py-20 md:py-40 relative">
      <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] h-[300px] md:w-[800px] md:h-[800px] bg-blu-500/[0.08] rounded-full blur-[120px] pointer-events-none" />
      <!-- The dot field the other sections stand on, fading out from the centre. -->
      <div class="pointer-events-none absolute inset-0 [mask-image:radial-gradient(ellipse_45%_60%_at_50%_50%,#000_35%,transparent)]" aria-hidden="true">
        <div class="cell-dots absolute inset-0"></div>
      </div>
      <div class="max-w-7xl mx-auto px-6 md:px-12 text-center relative z-10">
        <h2 data-aos="fade" class="text-4xl md:text-5xl lg:text-6xl font-bold text-slate-700 dark:text-white mb-6">
          Ready to get started?
        </h2>
        <p data-aos="fade" data-aos-delay="100" class="text-xl text-slate-700/75 dark:text-white/50 max-w-2xl mx-auto mb-10 leading-relaxed">
          Tell us about your project and we'll get back to you within 24 hours to arrange a consultation.
        </p>
        <NuxtLink
          to="/contact"
          data-aos="fade"
          data-aos-delay="200"
          class="inline-flex items-center rounded-full bg-blu-500 px-7 py-3.5 font-semibold text-dark-500 transition-colors hover:bg-blu-400"
        >
          Get in touch
        </NuxtLink>
      </div>
    </section>
    <ScrollToTop />
    <SectionDotNav
      :sections="[
        { label: 'Services', id: 'services' },
        { label: 'Work', id: 'work' },
        { label: 'About', id: 'about' },
        { label: 'Migration', id: 'migration' },
        { label: 'Support', id: 'support' },
        { label: 'Process', id: 'process' },
        { label: 'Agencies', id: 'agencies' },
        { label: 'Blog', id: 'blog' },
      ]"
    />
  </main>
</template>
